import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import headerBg from "../../../assets/background/headebg.png";
import headerMobileBg from "../../../assets/images/heroMobile3.jpg";
import { AppDispatch, RootState } from "../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import NavBar from "../../communs/NavBar";
import FooterSection from "../../../components/sections/FooterSection";
import Loader from "../../../biblio/Loader/Loader";
import { useNavigate, useParams } from "react-router-dom";
import HeroSectionDetailsProject from "../layout-details-project/HeroSectionDetailsProject";
import CardDetailsProgram from "../../../components/card-details-project/CardDetailsProgram";
import { toGetExternalProgramDetails } from "../../../apis/actions/programs.actions";
import RegistrationProgramCard from "./RegistrationProgramCard";
import OtherPrograms from "./OtherPrograms";
import Seo from "../../../components/seo/Seo";

const LayoutDetailsProgram = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { access_token } = useParams();
  const [loading, setLoading] = useState(true);

  const { externalProgramDetails } = useSelector(
    (state: RootState) => state?.programs
  );
  useEffect(() => {
    dispatch(toGetExternalProgramDetails(access_token));
    setLoading(true);
  }, [dispatch, access_token]);

  useEffect(() => {
    if (
      externalProgramDetails &&
      // eslint-disable-next-line eqeqeq
      Object.keys(externalProgramDetails)?.length == 0
    ) {
      navigate("/");
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalProgramDetails]);

  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <div className="takaful--layout-details">
      <Seo
        title={externalProgramDetails?.program_name}
        description={externalProgramDetails?.details}
        image={externalProgramDetails?.title_image_ids?.[0]}
      />
      <NavBar variant="projectDetails" />
      <HeroSectionDetailsProject
        title="البرامج"
        subTitle="الترشح للبرنامج"
        urlImage={headerBg}
        mobileImage={headerMobileBg}
      />
      <Row dir="rtl" justify={"space-between"}>
        <Col xxl={1} xl={1} lg={0} md={0} sm={0} xs={0}></Col>
        <Col
          xxl={14}
          xl={14}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
        >
          <CardDetailsProgram program={externalProgramDetails} />
        </Col>
        <Col
          xxl={7}
          xl={7}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
        >
          <RegistrationProgramCard id={externalProgramDetails?.id} />
        </Col>

        <Col xxl={1} xl={1} lg={0} md={0} sm={0} xs={0}></Col>
      </Row>
      <OtherPrograms />
      <FooterSection />
    </div>
  );
};

export default LayoutDetailsProgram;
